import Notification from '../../entities/notification/Notification'
import { onMessageListener } from '../../firebase'
import { store } from '../../services/store'
import { setNotification } from '../../services/store/actions/notifications/NotificationsAction'

export class NotificationRepository {
  async subscribeListener() {
    onMessageListener((notificationData) => {
      if (notificationData) {
        const notification = new Notification({
          ...notificationData,
        })

        store.dispatch(setNotification(notification))
      }
    })
  }
}
